export default __webpack_public_path__ + "static/media/IMG1681_r.cd83e794.jpg";